import React from 'react';
import SocialXIcon from './social-x';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function TwitterIcon(props) {
  return ___EmotionJSX(SocialXIcon, props);
}